var _a, _b, _c;
import { DriverReliabilityStatus, RouteStatus } from '../graphql/generated/api';
import { ORANGE, SHAMROCK, WARM_RED } from './colors';
export var ROUTES_STATUS_MAP = (_a = {},
    _a[RouteStatus.PENDING] = 'Pending',
    _a[RouteStatus.COMPLETED] = 'Completed',
    _a[RouteStatus.IN_PROGRESS] = 'In Progress',
    _a);
// $0, $5, $10, $15, ..., $100
export var ROUTES_ADJUSTMENTS = (function () {
    var result = {};
    for (var i = 0; i <= 100; i += 5) {
        result[i] = "$".concat(i);
    }
    return result;
})();
export var DRIVER_RELIABILITY_STATUS_COLOR = (_b = {},
    _b[DriverReliabilityStatus.ARRIVED] = SHAMROCK,
    _b[DriverReliabilityStatus.LATE_ARRIVAL] = ORANGE,
    _b[DriverReliabilityStatus.CALLED_OUT] = ORANGE,
    _b[DriverReliabilityStatus.NO_SHOW] = ORANGE,
    _b[DriverReliabilityStatus.RM_CANCELLATION] = SHAMROCK,
    _b[DriverReliabilityStatus.NOT_PREPARED] = ORANGE,
    _b[DriverReliabilityStatus.ROUTE_ABANDONMENT] = WARM_RED,
    _b[DriverReliabilityStatus.REFUSED_OFFER] = ORANGE,
    _b[DriverReliabilityStatus.RELEASED_ROUTE] = ORANGE,
    _b[DriverReliabilityStatus.DOUBLE_ROUTE] = SHAMROCK,
    _b[DriverReliabilityStatus.LATE_CANCELLATION] = ORANGE,
    _b);
export var DRIVER_RELIABILITY_STATUS_MAP = (_c = {},
    _c[DriverReliabilityStatus.ARRIVED] = 'Arrived',
    _c[DriverReliabilityStatus.LATE_ARRIVAL] = 'Late Arrival',
    _c[DriverReliabilityStatus.CALLED_OUT] = 'Called Out',
    _c[DriverReliabilityStatus.NO_SHOW] = 'No Show',
    _c[DriverReliabilityStatus.RM_CANCELLATION] = 'RM Cancellation',
    _c[DriverReliabilityStatus.NOT_PREPARED] = 'Not prepared',
    _c[DriverReliabilityStatus.ROUTE_ABANDONMENT] = 'Route Abandonment',
    _c[DriverReliabilityStatus.REFUSED_OFFER] = 'Refused Offer',
    _c[DriverReliabilityStatus.RELEASED_ROUTE] = 'Released Route',
    _c[DriverReliabilityStatus.DOUBLE_ROUTE] = 'Double Route',
    _c[DriverReliabilityStatus.LATE_CANCELLATION] = 'Late Cancellation',
    _c);
//# sourceMappingURL=routes.js.map